module.exports = __webpack_public_path__ + "img/img_signout_noAmount_top@2x.2f02d264.png";